import React, { useState, useCallback, useRef } from "react";
import "./Gallery.css";

const Gallery = () => {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const touchStartXRef = useRef(null);
  const touchEndXRef = useRef(null);

  // Handle touch events for swipe functionality
  const handleTouchStart = (e) => {
    touchStartXRef.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndXRef.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (!touchStartXRef.current || !touchEndXRef.current) return;

    const difference = touchStartXRef.current - touchEndXRef.current;
    const minSwipeDistance = 50;

    if (Math.abs(difference) > minSwipeDistance) {
      if (difference > 0) {
        handleNext();
      } else {
        handlePrev();
      }
    }

    touchStartXRef.current = null;
    touchEndXRef.current = null;
  };

  // Array media dengan teks yang akan ditampilkan saat diklik
  const media = [
    {
      type: "image",
      src: "/images/nobar/1.jpg",
      text: "UEFA CHAMPION LEAGUE 2022",
    },
    {
      type: "image",
      src: "/images/nobar/2.jpg",
      text: "PSM MAKASSAR VS PERSIJA",
    },
    {
      type: "image",
      src: "/images/nobar/3.jpg",
      text: "FINAL CHAMPION LEAGUE 2019",
    },
    {
      type: "image",
      src: "/images/nobar/4.jpg",
      text: "AREMA FC VS PERSEBAYA",
    },
    {
      type: "image",
      src: "/images/nobar/5.jpg",
      text: "BALI UNITED VS PERSIJA",
    },
    {
      type: "image",
      src: "/images/nobar/6.jpg",
      text: "MAN. UNITED VS LIVERPOOL",
    },
    {
      type: "image",
      src: "/images/nobar/7.jpg",
      text: "ELCLASICO DESEMBER 2017",
    },
    {
      type: "image",
      src: "/images/nobar/8.jpg",
      text: "BARCELONA VS CHELSEA",
    },
    {
      type: "image",
      src: "/images/nobar/9.jpg",
      text: "ELCLASICO DESEMBER 2017",
    },
    {
      type: "image",
      src: "/images/nobar/10.jpg",
      text: "ELCLASICO DESEMBER 2017",
    },
    {
      type: "image",
      src: "/images/nobar/11.jpg",
      text: "JUVENTUS VS REAL MADRID",
    },
    {
      type: "image",
      src: "/images/nobar/12.jpg",
      text: "DANAMON REDMATCH",
    },
    {
      type: "image",
      src: "/images/nobar/13.jpg",
      text: "ELCLASICO MARET 2019",
    },
    {
      type: "image",
      src: "/images/nobar/14.jpg",
      text: "BARCELONA VS ATLETICO MADRID",
    },
    {
      type: "video",
      src: "/images/video/bigreds.mp4",
      text: "Nobar Liverpool",
    },
    {
      type: "video",
      src: "/images/video/aremania.mp4",
      text: "Aremania Jakarta",
    },
    {
      type: "video",
      src: "/images/video/elclasico_prepare.mp4",
      text: "Nobar Elclasico Jakarta",
    },
    {
      type: "video",
      src: "/images/video/hajatan_madrid.mp4",
      text: "Madridista Indonesia Euporia",
    },
    {
      type: "video",
      src: "/images/video/konseramal_jakmania.mp4",
      text: "Konser Amal Jakmania",
    },
    {
      type: "video",
      src: "/images/video/nobar_1.mp4",
      text: "Elclasico",
    },
  ];

  // Array untuk gallery gathering
  const corporateGathering = [
    {
      type: "image",
      src: "/images/gathering/2.JPG",
      text: "Gathering 2024",
    },
    {
      type: "image",
      src: "/images/gathering/3.JPG",
      text: "Gathering 2024",
    },
    {
      type: "image",
      src: "/images/gathering/4.JPG",
      text: "Gathering 2024",
    },
    {
      type: "image",
      src: "/images/gathering/5.JPG",
      text: "Gathering 2024",
    },
    {
      type: "image",
      src: "/images/gathering/6.JPG",
      text: "Gathering 2024",
    },
    {
      type: "image",
      src: "/images/gathering/7.JPG",
      text: "Gathering 2024",
    },

    {
      type: "image",
      src: "/images/gathering/9.JPG",
      text: "Gathering 2024",
    },

    {
      type: "image",
      src: "/images/gathering/13.JPG",
      text: "Lauch Ceremony",
    },
    {
      type: "image",
      src: "/images/gathering/14.JPG",
      text: "Lauch Ceremony",
    },
    {
      type: "image",
      src: "/images/gathering/15.JPG",
      text: "Lauch Ceremony",
    },

    {
      type: "youtube",
      videoId: "PNIpdhCYbV8",
      text: "Final Champions",
    },

    {
      type: "youtube",
      videoId: "UnvVZvShdwA",
      text: "Hajatan Madridista Indonesia",
    },
    {
      type: "youtube",
      videoId: "1l2e1EaZqIQ",
      text: "Corporate Gathering 2022",
    },
    {
      type: "youtube",
      videoId: "tXuv1SzzvzE",
      text: "Corporate Gathering 2022",
    },
    {
      type: "youtube",
      videoId: "bdHRn-hjWZI",
      text: "Launch Ceremony",
    },
  ];

  const funrunGallery = [
    // { type: "image", src: "/images/funrun/1.jpeg", text: "Funrun 2025" },
    { type: "image", src: "/images/funrun/2.jpeg", text: "Funrun 2025" },
    { type: "image", src: "/images/funrun/3.jpeg", text: "Funrun 2025" },
    { type: "image", src: "/images/funrun/4.jpeg", text: "Private Party 2025" },
    { type: "image", src: "/images/funrun/5.jpeg", text: "Private Party 2025" },
    { type: "image", src: "/images/funrun/6.jpeg", text: "Private Party 2025" },
    { type: "image", src: "/images/funrun/7.jpeg", text: "Private Party 2025" },
    { type: "image", src: "/images/funrun/8.jpeg", text: "Private Party 2025" },
    { type: "image", src: "/images/funrun/9.jpeg", text: "Private Party 2025" },
  ];

  // Filter media berdasarkan tipe
  const images = media.filter((item) => item.type === "image");
  const videos = media.filter((item) => item.type === "video");
  const corporateGatheringImages = corporateGathering.filter(
    (item) => item.type === "image"
  );
  const funrunImages = funrunGallery.filter((item) => item.type === "image");
  const corporateGatheringVideos = corporateGathering.filter(
    (item) => item.type === "video" || item.type === "youtube"
  );

  // Menghitung total media dan offset untuk setiap section
  const imagesOffset = 0;
  const corporateGatheringImagesOffset = images.length;
  const funrunImagesOffset = images.length + corporateGatheringImages.length;
  const videosOffset =
    images.length + corporateGatheringImages.length + funrunImages.length;
  const corporateGatheringVideosOffset =
    images.length +
    corporateGatheringImages.length +
    funrunImages.length +
    videos.length;
  const totalMedia =
    images.length +
    corporateGatheringImages.length +
    funrunImages.length +
    videos.length +
    corporateGatheringVideos.length;

  // Fungsi untuk mendapatkan item berdasarkan index
  const getItemFromIndex = useCallback(
    (index) => {
      if (index < images.length) {
        return images[index];
      } else if (index < images.length + corporateGatheringImages.length) {
        return corporateGatheringImages[index - images.length];
      } else if (
        index <
        images.length + corporateGatheringImages.length + funrunImages.length
      ) {
        return funrunImages[
          index - (images.length + corporateGatheringImages.length)
        ];
      } else if (
        index <
        images.length +
          corporateGatheringImages.length +
          funrunImages.length +
          videos.length
      ) {
        return videos[
          index -
            (images.length +
              corporateGatheringImages.length +
              funrunImages.length)
        ];
      } else {
        return corporateGatheringVideos[
          index -
            (images.length +
              corporateGatheringImages.length +
              funrunImages.length +
              videos.length)
        ];
      }
    },
    [
      images,
      corporateGatheringImages,
      funrunImages,
      videos,
      corporateGatheringVideos,
    ]
  );

  // Menangani klik media
  const handleMediaClick = (index) => {
    setSelectedIndex(index);
  };

  // Menangani klik untuk menutup modal
  const handleCloseClick = () => {
    setSelectedIndex(null);
  };

  // Menangani navigasi ke media selanjutnya
  const handleNext = () => {
    setSelectedIndex((prevIndex) => (prevIndex + 1) % totalMedia);
  };

  // Menangani navigasi ke media sebelumnya
  const handlePrev = () => {
    setSelectedIndex((prevIndex) => (prevIndex - 1 + totalMedia) % totalMedia);
  };

  // Fungsi untuk render konten media dalam modal
  const renderModalContent = () => {
    if (selectedIndex === null) return null;

    const selectedItem = getItemFromIndex(selectedIndex);

    switch (selectedItem.type) {
      case "youtube":
        return (
          <iframe
            width="100%"
            height="480"
            src={`https://www.youtube.com/embed/${selectedItem.videoId}`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="modal-video"
          />
        );
      case "image":
        return (
          <img
            src={selectedItem.src}
            alt={selectedItem.text}
            className="modal-image"
          />
        );
      case "video":
        return (
          <video src={selectedItem.src} controls className="modal-video" />
        );
      default:
        return null;
    }
  };

  return (
    <div className="gallery-container">
      <h3 className="gallery-heading">BMS EVENT GALLERY</h3>

      {/* Bagian untuk menampilkan gambar nobar event */}
      <div className="media-section photos">
        <h2 className="media-title">Nobar Event Gallery</h2>
        <div className="media-grid">
          {images.map((item, index) => (
            <div
              key={index}
              className="media-card"
              onClick={() => handleMediaClick(imagesOffset + index)}
            >
              <img src={item.src} className="gallery-image" alt={item.text} />
            </div>
          ))}
        </div>
      </div>

      {/* Bagian untuk gambar corporate gathering */}

      <div className="media-section photos">
        <h4 className="media-title">Gathering Gallery</h4>
        <div className="media-grid">
          {corporateGatheringImages.map((item, index) => (
            <div
              key={index}
              className="media-card"
              onClick={() =>
                handleMediaClick(corporateGatheringImagesOffset + index)
              }
            >
              <img src={item.src} className="gallery-image" alt={item.text} />
            </div>
          ))}
        </div>
      </div>

      {/* Bagian untuk gambar corporate gathering */}

      <div className="media-section photos">
        <h3 className="media-title-bebenz">
          Anniversary Mercy W211 Bekasi Chapter
        </h3>
        <div className="media-grid">
          {funrunImages.map((item, index) => (
            <div
              key={index}
              className="media-card"
              onClick={() => handleMediaClick(funrunImagesOffset + index)}
            >
              <img src={item.src} className="gallery-image" alt={item.text} />
            </div>
          ))}
        </div>
      </div>

      {/* Bagian untuk video nobar event dan corporate gathering */}
      <div className="media-section videos">
        <h2 className="media-title">Video Gallery</h2>
        <div className="media-grid">
          {videos.map((item, index) => (
            <div
              key={index}
              className="media-card"
              onClick={() => handleMediaClick(videosOffset + index)}
            >
              <video src={item.src} className="gallery-video" />
            </div>
          ))}
        </div>

        <div className="media-grid">
          {corporateGatheringVideos.map((item, index) => (
            <div
              key={index}
              className="media-card"
              onClick={() =>
                handleMediaClick(corporateGatheringVideosOffset + index)
              }
            >
              {item.type === "youtube" ? (
                <iframe
                  width="100%"
                  height="200"
                  src={`https://www.youtube.com/embed/${item.videoId}`}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="gallery-video"
                />
              ) : (
                <video src={item.src} className="gallery-video" />
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Modal untuk menampilkan media yang dipilih */}
      {selectedIndex !== null && (
        <div className="modal-overlay" onClick={handleCloseClick}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
            {renderModalContent()}
            <p className="modal-text">{getItemFromIndex(selectedIndex).text}</p>
            <button className="modal-close" onClick={handleCloseClick}>
              X
            </button>
            <button className="modal-prev" onClick={handlePrev}>
              &lt;
            </button>
            <button className="modal-next" onClick={handleNext}>
              &gt;
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
